import { MenuButtonData } from '../system/Classes/MenuButtonData';

export const enrollmentMenuData: Array<MenuButtonData> = [
    {display:"本校特色", path:"/enrollment/features"},
    {display:"班級結構", path:"/enrollment/structure"},
    {display:"入學申請方法", path:"/enrollment/application"},
];
